import { Button } from "antd";
import "./summary-table.scss";
import { RiskStates } from "constants/index";

function RiskSummary(props: any) {
  const { riskSummaryData, onCountClick, detailsClickEnabled } = props;

  return (
    <div className="px-12">
      <div className="grid grid-cols-3 gap-y-0 summary-table table-auto rounded-lg border border-solid border-ciq-gray-50">
        <div className="summary-head rounded-tl-lg">Risk</div>
        <div className="summary-head">Submittals</div>
        <div className="summary-head rounded-tr-lg">Materials</div>

        <div className="summary-cell cell-with-padding">High</div>
        <div className="summary-cell">
          {detailsClickEnabled ? (
            <Button
              className="button-with-padding w-full text-left h-auto font-semibold outline-0 border-0"
              type="text"
              title="Click to view submittals at high risk"
              data-testid="risk-summary-submittal-high"
              onClick={() => {
                onCountClick({
                  type: "submittal",
                  risk: RiskStates.HIGH
                });
              }}
            >
              <span className="text-danger underlined-text">
                {riskSummaryData.submittal.high}
              </span>
            </Button>
          ) : (
            <span className="text-danger cell-with-padding">
              {riskSummaryData.submittal.high}
            </span>
          )}
        </div>
        <div className="summary-cell">
          {detailsClickEnabled ? (
            <Button
              className="button-with-padding w-full text-left h-auto font-semibold outline-0 border-0"
              type="text"
              title="Click to view materials at high risk"
              data-testid="risk-summary-material-high"
              onClick={() => {
                onCountClick({
                  type: "material",
                  risk: RiskStates.HIGH
                });
              }}
            >
              <span className="text-danger underlined-text">
                {riskSummaryData.material.high}
              </span>
            </Button>
          ) : (
            <span className="text-danger cell-with-padding">
              {riskSummaryData.material.high}
            </span>
          )}
        </div>

        <div className="summary-cell cell-with-padding">Medium</div>
        <div className="summary-cell">
          {detailsClickEnabled ? (
            <Button
              className="button-with-padding w-full text-left h-auto font-semibold outline-0 border-0"
              type="text"
              title="Click to view submittals at medium risk"
              data-testid="risk-summary-submittal-medium"
              onClick={() => {
                onCountClick({
                  type: "submittal",
                  risk: RiskStates.MEDIUM
                });
              }}
            >
              <span className="underlined-text">
                {riskSummaryData.submittal.medium}
              </span>
            </Button>
          ) : (
            <span className="cell-with-padding">
              {riskSummaryData.submittal.medium}
            </span>
          )}
        </div>
        <div className="summary-cell">
          {detailsClickEnabled ? (
            <Button
              className="button-with-padding w-full text-left h-auto font-semibold outline-0 border-0"
              type="text"
              title="Click to view materials at medium risk"
              data-testid="risk-summary-material-medium"
              onClick={() => {
                onCountClick({
                  type: "material",
                  risk: RiskStates.MEDIUM
                });
              }}
            >
              <span className="underlined-text">
                {riskSummaryData.material.medium}
              </span>
            </Button>
          ) : (
            <span className="cell-with-padding">
              {riskSummaryData.material.medium}
            </span>
          )}
        </div>

        <div className="summary-cell cell-with-padding rounded-bl-lg">Low</div>
        <div className="summary-cell cell-with-padding">
          {riskSummaryData.submittal.low}
        </div>
        <div className="summary-cell cell-with-padding rounded-br-lg">
          {riskSummaryData.material.low}
        </div>
      </div>
    </div>
  );
}

export default RiskSummary;
